import * as React from "react";
import styled, { css } from "styled-components";
import ElementDimensions from "components/common/ElementDimensions";
const HORIZONTAL_LAYOUT_BREAKPOINT = 500;
const Container = styled(ElementDimensions)`
  width: 100%;
`;
const StyledDl = styled.dl`
  width: 100%;
  margin: 0;

  dt {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-weight: normal;
    padding: ${({ theme }) => theme.spacings.xxs} ${({ theme }) => theme.spacings.xxs} 0;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  dd {
    margin: 0;
    padding: 0 ${({ theme }) => theme.spacings.xxs} ${({ theme }) => theme.spacings.xxs};
    border-bottom: 1px solid ${({ theme }) => theme.colors.table.row.divider};
    overflow-wrap: break-word;
    word-break: break-word;
  }

  dt:nth-of-type(odd),
  dd:nth-of-type(odd) {
    background-color: ${({ theme }) => theme.colors.table.row.backgroundStriped};
  }

  ${({ $horizontalLayout, theme }) => $horizontalLayout && css`
      display: grid;
      grid-template-columns: auto 1fr;

      dt {
        padding: ${theme.spacings.xxs};
        border-bottom: 1px solid ${theme.colors.table.row.divider};
      }

      dd {
        padding: ${theme.spacings.xxs};
      }
    `}
`;
const DefinitionList = ({ children }) => /* @__PURE__ */ React.createElement(Container, null, ({ width }) => /* @__PURE__ */ React.createElement(StyledDl, { $horizontalLayout: width > HORIZONTAL_LAYOUT_BREAKPOINT }, children));
export default DefinitionList;
